import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import CustomButton from "@components/buttons/CustomButton";
import SignUpNoise from "@assets/noise/signup-noise.png";
import SignUpCarousel from "../components/carousel/SignUpCarousel";
import InputDiv from "../components/InputDiv";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import WarningMessage from "@components/errors/WarningMessage";
import { sendOtpResponse } from "@services/models/Authentication/Authentication";
import { authenticationApiService } from "@services/apis/Authentication";

const LoginPageMobile = () => {
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const continueButtonRef = useRef<HTMLButtonElement>(null);

  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  const checkValidEmail = () => {
    if (email.length > 0) {
      const emailRegex = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      );
      if (!emailRegex.test(email)) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleSubmit = async () => {
    try {
      setIsButtonLoading(true);
      const response: sendOtpResponse = await authenticationApiService.sendOtp(
        email
      );
      const csrfToken = response.data.csrfToken;
      console.log("email", email);
      console.log("csrfToken", csrfToken);
      secureLocalStorage.setItem("loginEmail", email);
      secureLocalStorage.setItem("loginCsrfToken", csrfToken);
      navigate("/verifyOtp", { state: { csrfToken, email } });
      console.log(csrfToken);
    } catch (Exception) {
      console.log(Exception);
      setError("Invalid user login!");
    } finally {
      setIsButtonLoading(false);
    }
  };

  const checkLogin = () => {
    const jwt = secureLocalStorage.getItem("jwt");
    if (jwt) {
      navigate("/");
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);
  return (
    <div
      className=" bg-bg-button-secondary h-[100dvh] overflow-hidden flex flex-col bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${SignUpNoise})` }}
    >
      {/* Carousel and Input Container */}
      <div className="h-[60dvh]">
        <SignUpCarousel />
      </div>

      {/* This container will take up the remaining space */}
      <div className="flex flex-col flex-grow  ">
        {/* InputDiv fills remaining space */}
        <InputDiv text="Login to your dashboard!" className="flex-grow">
          <div className="mt-[32px] mb-[24px]">
            <GlobalTextInputField
              label="Email id"
              placeholder="Email id"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="p-[0px] my-4">
            <CustomButton
              ref={continueButtonRef}
              text="CONTINUE"
              onClick={handleSubmit}
              isActive={checkValidEmail() ? true : false}
              isButtonLoading={isButtonLoading}
            />
          </div>
          <WarningMessage message={error ?? ""} condition={error !== null} />
          <span className="text-text-error text-[14px]">{error}</span>
        </InputDiv>
      </div>
    </div>
  );
};

export default LoginPageMobile;
